import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=6f16f5cf&scoped=true&"
import script from "./EditClient.vue?vue&type=script&lang=js&"
export * from "./EditClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f16f5cf",
  null
  
)

export default component.exports